module.exports = __webpack_public_path__ + "img/92.1.e8dcb6a2.jpg";